import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../../src/data/static/strings'
import { RootStore } from '../../src/data/store'
import { dateFormatter, DateFormatTypes, updateEndDateTimeInRequest } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = ({ data }: any) => {
  const { content, page } = data
  const retData = content?.map((item: any) => {
    return {
      ...item,
      createdAt: `${dateFormatter(item?.createdAt ?? 'NA', DateFormatTypes.DATE_ONLY)}`,
    }
  })
  return { page: page, history: retData }
}

const getTokenizationHistory = (tokens: any, reqBody: any) => {
  const isCustomRange = RootStore.tokenizationRequests.selectedDate.dateLabel === actionMenuStrings.customDate

  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.vaultHistory,
    body: isCustomRange ? reqBody : updateEndDateTimeInRequest(reqBody, RootStore.tokenizationRequests.selectedDate),
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getTokenizationHistory }
